/**
 * Formula Config Service
 * 方程式設定主檔 API 服務
 */

import axios from '../api/axios';

const BASE_URL = '/api/formula-config';

export interface FormulaParameter {
  symbol:         string;
  name_zh:        string;
  name_en:        string;
  unit?:          string;
  description_zh?: string;
  description_en?: string;
}

export interface FormulaConfigItem {
  id:           number;
  formula_code: string;
  name_zh:         string;
  name_en:         string;
  ghg_types:       number[];
  formula_latex:   string | null;
  parameters:      FormulaParameter[];
  description_zh:  string | null;
  description_en:  string | null;
  is_active:       boolean;
  edit_by:         number;
  created_at:      string;
  updated_at:      string | null;
}

export interface FormulaConfigCreate {
  formula_code:   string;
  name_zh:        string;
  name_en:        string;
  ghg_types?:     number[];
  formula_latex?: string;
  parameters?:    FormulaParameter[];
  description_zh?: string;
  description_en?: string;
  is_active?:     boolean;
}

const formulaConfigService = {
  list: async (params?: {
    is_active?: boolean;
    keyword?: string;
  }): Promise<FormulaConfigItem[]> => {
    const res = await axios.get(BASE_URL, { params });
    return res.data;
  },

  listActive: async (): Promise<FormulaConfigItem[]> => {
    const res = await axios.get(BASE_URL, { params: { is_active: true } });
    return res.data;
  },

  get: async (id: number): Promise<FormulaConfigItem> => {
    const res = await axios.get(`${BASE_URL}/${id}`);
    return res.data;
  },

  create: async (data: FormulaConfigCreate): Promise<FormulaConfigItem> => {
    const res = await axios.post(BASE_URL, data);
    return res.data;
  },

  update: async (id: number, data: FormulaConfigCreate): Promise<FormulaConfigItem> => {
    const res = await axios.put(`${BASE_URL}/${id}`, data);
    return res.data;
  },

  remove: async (id: number): Promise<void> => {
    await axios.delete(`${BASE_URL}/${id}`);
  },
};

export default formulaConfigService;
